import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import type { HealthCheckActionResultDto, HealthCheckFindingDto } from '../models/healthCheck.types'

import { appHttp, unwrapEnvelope } from '@/shared/http'

const FEATURE_OWNED_ERRORS: AxiosRequestConfig = {
  suppressGlobalErrorHandler: true,
  meta: { suppressGlobalErrorHandler: true },
}

export class HealthCheckApi {
  constructor(private readonly http: AxiosInstance = appHttp) {}

  private base(accountId: number, workspaceId: number): string {
    return `/accounts/${accountId}/workspaces/${workspaceId}/configuration_analysis`
  }

  async list(accountId: number, workspaceId: number): Promise<HealthCheckFindingDto[]> {
    const response = await this.http.get(this.base(accountId, workspaceId), FEATURE_OWNED_ERRORS)
    return unwrapEnvelope<HealthCheckFindingDto[]>(response)
  }

  async dismiss(accountId: number, workspaceId: number, id: number): Promise<void> {
    await this.http.patch(
      `${this.base(accountId, workspaceId)}/${id}/dismiss`,
      undefined,
      FEATURE_OWNED_ERRORS,
    )
  }

  async restore(accountId: number, workspaceId: number, id: number): Promise<void> {
    await this.http.patch(
      `${this.base(accountId, workspaceId)}/${id}/restore`,
      undefined,
      FEATURE_OWNED_ERRORS,
    )
  }

  async runAction(path: string): Promise<HealthCheckActionResultDto> {
    const response = await this.http.post(path, undefined, FEATURE_OWNED_ERRORS)
    unwrapEnvelope<unknown>(response)
    return { message: response.data.message ?? null }
  }
}

export const healthCheckApi = new HealthCheckApi()
